import React from "react";
import CommonLoad from "../../Spin";
var prefix = 'sfx-react-ui';

var Loading = function Loading(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? true : _ref$loading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-mask")
  }, /*#__PURE__*/React.createElement(CommonLoad, {
    size: 0.2
  })));
};

export default Loading;